import React, {useMemo} from "react";

import TableBody from "./table/TableBody";
import TableHead from "./table/TableHead";
import TableLegend from "./table/TableLegend";
import usePreviouslyOrderedProducts from "../../../hooks/usePreviouslyOrderedProducts";

const ProductDetailsTable = ({productDetails, urlIconCar, loadingPriceList, productPriceList, contactDetails}) => {

    const dataTable = productDetails?.data_table ?? {};
    const dataIndexes = Object.keys(dataTable);

    const isSpecial = false;
    const popup = false;
    const active = productDetails?.active;
    const toggleId = productDetails?.toggle_id;
    const activeIndex = 1;

    const showSpecials = productDetails?.show_specials;
    const showOrderButton = productDetails?.show_order_button;
    const showHead = dataIndexes.includes('head');
    const showLegend = dataIndexes.includes('legend');
    const showBody = dataIndexes.includes('body');

    const {
        products: previouslyOrderedProducts,
        loading: loadingPreviouslyOrderedProducts
    } = usePreviouslyOrderedProducts(
        useMemo(() => dataTable.body.map((item) => item.product_code), [productDetails]),
        showSpecials
    );

    return (
        <div
            className={`table-responsive ${toggleId ? 'toggle-btn-wrapper' : ''} table__wrapper table-responsive-xl`}
            data-toggle_id={toggleId ?? ''}
            data-ga-view={null}
            data-gaactive={active ? 1 : 0}
            data-gadata={dataTable.ga_data ?? ''}
            style={{display: activeIndex ? "contents" : "none"}}
        >
            <table className="table table-sticky table-bordered tablet-table-wrap-normal table-hover table-first-col-bold">
                {showHead &&
                    <TableHead
                        key={'product_details_table_head'}
                        showLegend={showLegend}
                        headList={dataTable.head}
                        showSpecials={showSpecials}
                        showOrderButton={showOrderButton}
                    />}
                {showLegend &&
                    <TableLegend
                        key={'product_details_table_head_legend'}
                        data={dataTable}
                        showSpecials={showSpecials}
                        showOrderButton={showOrderButton}
                    />}
                {showBody &&
                    <TableBody
                        key={'product_details_tbody'}
                        data={dataTable}
                        popup={popup}
                        isSpecial={isSpecial}
                        showSpecials={showSpecials}
                        urlIconCar={urlIconCar}
                        productPriceList={productPriceList}
                        loadingPriceList={loadingPriceList}
                        previouslyOrderedProducts={previouslyOrderedProducts}
                        loadingPreviouslyOrderedProducts={loadingPreviouslyOrderedProducts}
                        contactDetails={contactDetails}
                        showOrderButton={showOrderButton}
                    />}
            </table>
        </div>
    )
}

export default ProductDetailsTable;